import { t } from 'i18next';
import { isDevelopment } from '../../../utility/env';

const PAYMENT_METHODS = {
  checkout: {
    key: 'creditDebit',
    label: 'Credit/Debit Card',
    icon: 'DebitCardIcon',
    size: 24,
    component: 'CreditDebitWithCheckout',
    hideNewBadge: true,
  },
};

const LANGUAGES = [
  { key: 'ar', label: 'العربية', labelShort: 'العربية', alternate: 'en', rtl: true, darkMode: false },
  { key: 'en', label: 'English', labelShort: 'EN', alternate: 'ar', rtl: false, darkMode: false },
];

const APP_LOGO = {
  title: 'Bayut',
  icon: { rtl: 'BayutAppArabicLogo', ltr: 'BayutAppLogo' },
  linkIos: {
    en: 'https://apps.apple.com/pk/app/bayut-qatar/id6740854041',
    ar: 'https://apps.apple.com/pk/app/bayut-qatar/id6740854041',
  },
  // qrCodeSrc: `${getBaseURL()}/profolio-assets/images/downloadAppQRCode.svg`,
  linkPlayStore: {
    en: 'https://play.google.com/store/apps/details?id=com.bayut.bayutqa',
    ar: 'https://play.google.com/store/apps/details?id=com.bayut.bayutqa',
  },
  getLogoText: () => ({
    en: 'Qatar',
    ar: 'قطر',
  }),
  getLogoTextPlacement: () => ({
    en: {
      horizontal: 530,
      vertical: 550,
      widht: 140,
      height: 32,
    },
    ar: {
      horizontal: 310,
      vertical: 550,
      widht: 125,
      height: 32,
    },
  }),
};

const USER_LOCATIONS = {
  label: 'Region',
  level: '2',
};

const LISTING_LOCATIONS = {
  label: 'Region',
  level: '2',
};

const PLATFORM_CONFIGS = {
  bayut: { hasStatsInOwnDb: false, refetchStatsOnFilterChange: false },
  dubizzle: { hasStatsInOwnDb: false, refetchStatsOnFilterChange: false },
};
const appConstants = Object.freeze({
  // Unused
  LOCALE: 'ar-QA',
  TIMEZONE: 'Asia/Karachi',
  USER_LOCATIONS,
  LISTING_LOCATIONS,
  TITLE: 'Bayut Qatar',
  SHORT_TITLE: 'QA',
  COUNTRY_CODE: 'QA',
  PHONE_REGEX: /^(\+974|974|00974)?\d{8}$/,
  PHONE_CODE: '+974',
  CURRENCY: 'QAR',
  CURRENCY_SYMBOL: (str) => (str ? `${t('QAR')}${str}` : t('QAR')),
  LINK_TITLE: 'bayut.qa',
  SOCIAL_SLUG: { FACEBOOK: '', INSTAGRAM: '', X: '', LINKEDIN: '' },
  SHOW_SOCIALS: false,
  FONT_FAMILY_LITE: 'Lato, Droid Arabic Kufi, sans-serif',
  AUTH_TOKEN_COOKIE_KEY: 'byt_cd',
  USER_LOCAL_STORAGE_KEY: 'user_info',
  NUMBER_SYSTEM: 'western',
  PLATFORM_CONFIGS,
  LANGUAGES,
  PAYMENT_METHODS,
  APP_LOGO,
  HIDE_PREFERENCES: true,
  HIDE_LICENSES: true,
  SAVED_SEARCHES_ENABLED: true,
  ALLOW_PACKAGE_UPGRADE: false,
  ENABLE_FAL_LICENSE: false,
  ENABLE_NAFATH: false,
  ENABLE_SMART_CREDITS_UTILISATION: false,
  LOCATION_LEVELS: { city: 2 },
  KC_ENABLED: !isDevelopment,
  SHOW_ACCOUNT_MANAGER: true,
  SHOW_HELP_AND_SUPPORT: false,
  DAILY_RENTAL_ENABLED: false,
  SHOW_NATIONAL_ADDRESS: false,
  IS_CREDIT_CAPPING_ENABLED: false,
  INVITE_USER_TO_AGENCY_ENABLED: false,
  ADD_USER_TO_AGENCY_FORM_ENABLED: false,
  HAS_MEMBER_AREA: true,
  /** Listings tables: pin the Upgrades (Elite / Feature) column beside the already-pinned actions column. */
  STICKY_LISTING_UPGRADES_COLUMN: true,
  /** Listing Posted upsell: show a Skip link that leaves for My Listings without applying anything. */
  SHOW_UPSELL_SKIP: true,
  /** Listings tables: fold View on Bayut / Dubizzle, Edit and the more-menu items into one ⋮ menu. */
  COMPACT_LISTING_ROW_ACTIONS: true,
  TRUE_CHECK_ENABLED: false,
  HAVE_LOGIN_SCREEN: isDevelopment,
  CONVERT_TO_AGENCY: true,
  SHOW_REGA_DETAIL: false,
  SHOW_REGA_FOOTER: false,
  POST_LISTING_POPUP: false,
  SHOW_SEARCH_HEADER: false,
  SHOW_AMENITIES_ICON: true,
  ZENDESK: false,
  IS_LMS_ENABLED: false,
  MANAGE_QUOTA_ENABLED: false,
  PROFILE_COMPLETION_APPLICABLE: false,
  TRU_BROKER_ENABLED: false,
  OFFPLAN_ENABLED: false,
  ALLOW_CREDITS_TOPTUP: false,
  MULTIPLATFROM_VIEW: false,
  SHOW_PLATFORM_LOGO: true,
  AGENCY_STAFF_HEADER: true,
  CURRENCY_ORDER_SUMMARY: true,
  PITCH_MOBILE_APP: false,
  PUSH_CONTENT_ON_SIDEBAR_EXPAND: false,
  SHOW_PAYMENT_METHODS: false,
  SHOW_FRACTION_CURRENCY: true,
  PITCH_MULTIPLATFORM_PACKAGES: true,
  SHOW_QUALITY_TIP: false,
  PUSH_NOTIFICATIONS_ENABLED: false,
  IMAGE_ANALYSER: false,
  SERVICE_AREAS_ENABLED: false,
  MONTHLY_CREDIT_PURCHASE: true,
  SHOW_VIDEO_FIELD: false,
  /** Post listing: show title/description for the active UI locale only (not both languages at once). */
  LOCALE_SPECIFIC_TITLE_DESCRIPTION: true,
  SHOW_POST_LISTING_PACKAGE_INFO: false,
  DISABLE_POST_LISTING_POSTING_AS: true,
  /** Post listing: hide beds/baths/furnished until a property type is selected (matches live). */
  DEFER_BEDS_BATHS_FURNISHED_UNTIL_PROPERTY_TYPE: true,
  /** Edit listing: show Property Type locked. Top-level, not under FORM (any FORM block enables the Bayut redesign). */
  DISABLE_PROPERTY_TYPE_ON_EDIT: true,
  // Post listing: show Total Floors / Floor Number / Built-up Area (rollout of the Bayut KSA fields).
  SHOW_FLOOR_AND_BUILTUP_FIELDS: true,
  CAPTCHA_CONFIG: {
    siteKey: process.env.REACT_APP_STRAT_RECAPTCHA_KEY,
    theme: 'light',
    size: 'normal',
    enableWithKCOtpEndpoints: true,
  },
});

export default appConstants;
